import gql from 'graphql-tag'

const REPROCESS_USER_ASSESSMENT_SCORES = gql`
mutation reprocessUserAssessmentScores($id: ID!) {
  reprocessUserAssessmentScores(id: $id)
}
`

export default REPROCESS_USER_ASSESSMENT_SCORES
